import React, { FC, memo, useMemo, useState } from 'react';

import { useAuth } from 'context/auth';
import { TabPanel } from 'devextreme-react';

import { DriverSalaryAdjustments } from './components';
import SalaryDrivers from './components/SalaryDrivers';

const itemTitleRender = (tab: { name: string; index: number }) => {
  return <span>{tab.name}</span>;
};

const ItemsTabs = memo((props: { index: number; data: any }, prev: any) => {
  switch (props.index) {
    case 0:
      return (
        <div className="tab-content">
          <SalaryDrivers />
        </div>
      );
    case 1:
      return (
        <div className="tab-content">
          <DriverSalaryAdjustments />
        </div>
      );
    default:
      return <div></div>;
  }
});

const SalaryDriversMain: FC = () => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const { getClaims }: any = useAuth();

  const isVisibleAdjustments = getClaims(['CanLookSalaryFixedAdjustments']);

  const tabs = useMemo(
    () => [
      {
        name: 'Расчет зарплат',
        index: 0,
      },
      {
        name: 'Корректировки',
        index: 1,
        visible: isVisibleAdjustments,
      },
    ],
    [isVisibleAdjustments],
  );

  return (
    <div>
      <TabPanel
        height="auto"
        dataSource={tabs}
        selectedIndex={selectedIndex}
        onOptionChanged={(e) => {
          if (e.name === 'selectedIndex') {
            setSelectedIndex(e.value);
          }
        }}
        itemTitleRender={itemTitleRender}
        animationEnabled={false}
        itemComponent={ItemsTabs}
      />
    </div>
  );
};

export default SalaryDriversMain;
